import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './AuthService/auth.service'
import { Configuration } from '../Configuration';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  model: any = {};
  loginInvalid = false;
  public loading = false;
  public error: any = null;
  private events: any = {};
  public apptext:string

  constructor(private router: Router,
    private authService: AuthenticationService,public config: Configuration) { 
      this.apptext = this.config.apptext;
    }

  login() {
    this.error = null;
    if (this.events.login) this.events.login.unsubscribe();
    this.events.login = this.authService.login(this.model.email, this.model.password)
      .subscribe(result => {

        this.router.navigate(['/Home']);
      
      }, err => {
        this.loginInvalid = true;
        this.error = 'Invalid Username or Password, Try again!';
      });
  }

  ngOnInit() {
    this.authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts